import { LOCALES } from "common/constants";
import { readCookie } from "common/FunctionUtils";
import { blobURL } from "common/StringUtils";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { GiCheckMark } from "react-icons/gi";
import { useNavigate } from "react-router-dom";

export const AdSense = ({ setShowAd }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const language = localStorage.getItem("i18nextLng");
  const adSenseBanner = `${blobURL}/AdSenseBanner.jpg`;

  const [isShow, setIsShow] = useState(
    readCookie("_cc_cookieConsent") ? true : false
  );

  useEffect(() => {
    if (!isShow ) {
      let interval;
      const checkCookies = () => {
        const isConsentCookie = readCookie("_cc_cookieConsent");

        if (isConsentCookie) {
          if (interval) {
            clearInterval(interval);
          }
          setTimeout(() => {
            setIsShow(true);
          }, 60000);
        }
      };
      checkCookies();
      interval = setInterval(checkCookies, 1000);
      return () => clearInterval(interval);
    }
  }, []);

  
  return (
    <Modal
      show={isShow}
      size="lg"
      style={{ margin: "5px 0" }}
      className="modalone fade.modalone.modal"
      centered
      onHide={() => setIsShow(false)}
    >
      <Modal.Body style={{ padding: "0" }}>
        <button
          type="button"
          className="close"
          aria-label="Close"
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            zIndex: "999",
            padding: "10px",
          }}
          onClick={() => setShowAd(false)}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="container invozio p-0">
          <div className="row discover">
            <div className="col-md-5 p-0">
              <img
                src={adSenseBanner}
                alt="invozio-adsense-banner"
                className="img-fluid"
                style={{ objectFit: "cover", height: "100%" }}
              />
            </div>

            <div className="col-md-7" style={{ padding: "15px 20px" }}>
              <div className="content_new lorem">
                <h4 style={{ color: "#654eb8", fontWeight: "bold" }}>
                  {t("Discover Invozio")}
                </h4>
                <p
                  className="font-weight-bold"
                  style={{ fontSize: "14px", color: "#343a40" }}
                >
                  {t("Simple billing with no hidden fees and flexible support")}
                </p>
                <ul>
                  <li
                    className="d-flex align-items-center"
                    style={{ margin: "0 0 8px" }}
                  >
                    <p className="d-inline mr-2">
                      <GiCheckMark color="#654eb8" />
                    </p>
                    <div className="d-inline">
                      <h6 className="font-weight-bold mb-0">
                        {t("No fixation")}
                      </h6>
                      {t(
                        "create your account at Invozio.com completely free of charge!"
                      )}
                    </div>
                  </li>
                  <li
                    className="d-flex align-items-center"
                    style={{ margin: "0 0 8px" }}
                  >
                    <p className="d-inline mr-2">
                      <GiCheckMark color="#654eb8" />
                    </p>
                    <div className="d-inline">
                      <h6 className="font-weight-bold mb-0">
                        {t("We take care of all administrative handling")}
                      </h6>
                      {t("including accounting and handling of tax payments")}
                    </div>
                  </li>
                  <li
                    className="d-flex align-items-center"
                    style={{ margin: "0 0 8px" }}
                  >
                    <p className="d-inline mr-2">
                      <GiCheckMark color="#654eb8" />
                    </p>
                    <div className="d-inline">
                      <h6 className="font-weight-bold mb-0">
                        {t("No fixed monthly fee")}
                      </h6>
                      {t(
                        "instead, you pay only 1.9% of the invoice amount at each invoicing occasion"
                      )}
                    </div>
                  </li>
                  <li
                    className="d-flex align-items-center"
                    style={{ margin: "0 0 8px" }}
                  >
                    <p className="d-inline mr-2">
                      <GiCheckMark color="#654eb8" />
                    </p>
                    <div className="d-inline">
                      <h6 className="font-weight-bold mb-0">
                        {t("Professional support and qualified advice")}
                      </h6>
                      {t("by email or phone, every non-holiday weekday.")}
                    </div>
                  </li>
                </ul>
                <div className="text-center">
                  <Button
                    variant=""
                    className="adsense_theme_btn"
                    onClick={() => {
                      setShowAd(false);
                      navigate(
                        language === LOCALES.EN_US
                          ? `/emailregister?lang=${LOCALES.EN_US}`
                          : `/e-postregister?lang=${LOCALES.SV_SE}`
                      );
                    }}
                  >
                    {t("Create Free Account")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
